export default {
	params: [],
	validate: (value) => {
		let regex = new RegExp(/\d{4}$/, 'i');
		let match = regex.exec(value);

		if (match.length == 0) {
			return false;
		}

		let date = new Date();
		let currentYear = date.getFullYear();

		if (currentYear > value) {
			return false;
		}

		return true;
	},
	message: 'Invalid year'
};
